import axios from 'axios'
import Constants from '@/js/constant'

const HOST = Constants.hosts.hrurl
const subVendor = `${HOST}sub-vendor`

export default {
  getSubVendors(context1) {
    const context = context1
    const params = { params: { query: context.$store.state.query.query, page: context.$store.state.query.page - 1 } }
    axios.get(subVendor, params).then(response => {
      context.setSubVendors(response.data)
    }, () => {
    })
  },
  addSubVendor(context1, body) {
    const context = context1
    context.$vs.loading()
    axios.post(subVendor, body).then(response => {
      context.$vs.loading.close()
      context.subVendorAdded(response.data)
      context.$store.state.lists.commonLists.lists['sub-vendors'] = response.data.full_list
    }, error => {
      context.$vs.loading.close()
      context.subVendorNotAdded(error.response.data.return_message)
    })
  },
  updateSubVendor(context1, id, body) {
    const context = context1
    context.$vs.loading()
    axios.put(`${subVendor}/${id}`, body).then(response => {
      context.$vs.loading.close()
      context.subVendorUpdated(response.data)
      context.$store.state.lists.commonLists.lists['sub-vendors'] = response.data.full_list
    }, error => {
      context.$vs.loading.close()
      context.subVendorNotUpdated(error.response.data.return_message)
    })
  },
  delete(context1, id) {
    const context = context1
    context.$vs.loading()
    axios.delete(`${subVendor}/${id}`).then(response => {
      context.$vs.loading.close()
      context.parentDeleted(response.data)
      context.$store.state.lists.commonLists.lists['sub-vendors'] = response.data.full_list
    }, error => {
      context.$vs.loading.close()
      context.parentNotDeleted(error.response.data.return_message)
    })
  },
  getSubVendorById(context1, id) {
    const context = context1
    context.$vs.loading()
    axios.get(`${subVendor}/${id}`).then(response => {
      context.$vs.loading.close()
      context.setSubVendor(response.data)
    }, error => {
      context.$vs.loading.close()
      context.subVendorNotFound(error.response.data.return_message)
    })
  },

}
